// import AOS from 'aos';
jQuery(function($) {

	const header = $('#header');
	const root = document.documentElement;

	$(document).ready(function() {

		function calcHeaderHeight() {
			var stickyHeight = header.outerHeight();
			root.style.setProperty('--header-height', stickyHeight + 'px');
			$('body').addClass('has-header-height');
		}

		function calcHeights() {
			calcHeaderHeight();
		}

		calcHeights();

		window.addEventListener( 'resize', calcHeights );

		$('.is-style-aos-window-center').each( function(i, el) {
			$('img', el).attr('data-aos', 'window-center');
		});

		$('.is-style-aos-window-bottom').each( function(i, el) {
			$('img', el).attr('data-aos', 'window-bottom');
		});

		// init AOS
		AOS.init({
			// Global settings:
			// disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
			// startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
			// initClassName: 'aos-init', // class applied after initialization
			// animatedClassName: 'aos-animate', // class applied on animation
			// useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
			// disableMutationObserver: false, // disables automatic mutations' detections (advanced)
			// debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
			// throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


			// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
			// offset: 120, // offset (in px) from the original trigger point
			// delay: 0, // values from 0 to 3000, with step 50ms
			duration: 1000, // values from 0 to 3000, with step 50ms
			// easing: 'ease', // default easing for AOS animations
			once: true, // whether animation should happen only once - while scrolling down
			// mirror: false, // whether elements should animate out while scrolling past them
			// anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

		});

		// init ScrollMagic controller
		var controller = new ScrollMagic.Controller();

		// build scene
		var scene = new ScrollMagic.Scene({triggerElement: "body"})
		.addTo(controller)
		.on("update", function (e) {
		    var scrollPos = e.target.controller().info("scrollPos");
		    var scrollDirection = e.target.controller().info("scrollDirection");
		    if ( scrollPos > header.outerHeight() ) {
		    	$('body').addClass('sticky-nav');
		    	if ( scrollDirection == "FORWARD" ) {
		    		$('body').addClass('hide-nav');
		    	} else {
		    		$('body').removeClass('hide-nav');
		    	}
		    } else {
		    	$('body').removeClass('sticky-nav hide-nav');
		    }
		});

		var folderFlip = $('.ssf-folder-flip');

		if ( folderFlip.length ) {
			var scene2 = new ScrollMagic.Scene({
				triggerElement: folderFlip.next()[0],
				triggerHook: 'onEnter'
			})
			.addTo(controller)
			.on("enter", function (e) {
			    folderFlip.addClass('exited');
			    var folderFlipHeight = folderFlip.outerHeight();
			    var windowHeight = $(window).height();
			    $('.folder-flip-tag').each( function(i, el) {

			    	var translateY = folderFlipHeight - windowHeight - $(this).position().top;
			    	$(this).css('transform', 'translateY('+translateY+'px)');
			    });
			})
			.on("leave", function (e) {
			    folderFlip.removeClass('exited');
			    $('.folder-flip-tag').css('transform', '');
			});
		}

		

		$('.menu-toggle').click( function(e) {
		  $('body').toggleClass('menu-open');
		});

		var makers = $('.ssf-makers');

		if ( makers.length ) {
			$('.carousel', makers).slick( {
				infinite: false,
				dots: false,
				arrows: false,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				slide: '.slide',
				// speed: 150,
				touchThreshold: 100,
				swipeToSlide: true,
				responsive: [
				    {
				      breakpoint: 900,
				      settings: {
				        slidesToShow: 3,
				      }
				    },
				    {
				      breakpoint: 650,
				      settings: {
				        slidesToShow: 2,
				      }
				    }
				]
			});

			$('.carousel', makers)
				.mouseenter(function() {
					$('.drag-cursor').addClass('visible');
				})
				.mouseleave(function() {
					$('.drag-cursor').removeClass('visible');
				});
			$('.carousel', makers).mousemove(function(event) {
		        var offset = $(this).offset();
		        var x = event.pageX- offset.left;
		        var y = event.pageY- offset.top;
		        $(".drag-cursor").css({'left': x+'px', 'top': y+'px'});
		    });
		}

		var dragCarousel = $('.ssf-drag-carousel');

		if ( dragCarousel.length ) {
			$('.carousel', dragCarousel).slick( {
				infinite: false,
				dots: false,
				arrows: false,
				variableWidth: true,
				slide: '.slide',
				// speed: 150,
				touchThreshold: 100,
				swipeToSlide: true
			});

			$('.carousel', dragCarousel)
				.mouseenter(function() {
					$('.drag-cursor').addClass('visible');
				})
				.mouseleave(function() {
					$('.drag-cursor').removeClass('visible');
				});
			$('.carousel', dragCarousel).mousemove(function(event) {
		        var offset = $(this).offset();
		        var x = event.pageX- offset.left;
		        var y = event.pageY- offset.top;
		        $(".drag-cursor").css({'left': x+'px', 'top': y+'px'});
		    });
		}

		var localBrokersCarousel = $('.brokers-local-carousel');

		if ( localBrokersCarousel.length ) {
			localBrokersCarousel.each( function(e) {
				$('.carousel', this).slick({
					infinite: true,
					dots: true,
					appendDots: $('.slick-controls', this),
					arrows: true,
					appendArrows: $('.slick-controls', this),
					prevArrow: '<div class="slick-prev"></div>',
					nextArrow: '<div class="slick-next"></div>',
					mobileFirst: true,
					slidesToShow: 2,
					slidesToScroll: 2,
					responsive: [
					    {
					      breakpoint: 900,
					      settings: {
					        slidesToShow: 4,
							slidesToScroll: 4,
					      }
					    },
					    {
					      breakpoint: 650,
					      settings: {
					        slidesToShow: 3,
							slidesToScroll: 3,
					      }
					    }
					]
				});
			});
		}

		var allBrokersCarousel = $('.all-brokers-carousel');

		if ( allBrokersCarousel.length ) {
			allBrokersCarousel.each( function(e) {
				var currentCarousel = this;
				$('.carousel', currentCarousel).slick({
					infinite: true,
					dots: true,
					appendDots: $('.slick-controls', this),
					arrows: true,
					appendArrows: $('.slick-controls', this),
					prevArrow: '<div class="slick-prev"></div>',
					nextArrow: '<div class="slick-next"></div>',
					mobileFirst: true,
					slidesToShow: 2,
					slidesToScroll: 2,
					responsive: [
					    {
					      breakpoint: 900,
					      settings: {
					        slidesToShow: 4,
							slidesToScroll: 4,
					      }
					    },
					    {
					      breakpoint: 650,
					      settings: {
					        slidesToShow: 3,
							slidesToScroll: 3,
					      }
					    }
					]
				});
				$('.places-toggles button', currentCarousel).click( function(e) {
					$('.carousel', currentCarousel).slick('slickUnfilter');
					if ( $(this).hasClass('active') ) {
						$(this).removeClass('active');
					} else {
						$('.carousel', currentCarousel).slick('slickFilter','.'+$(this).data('toggle'));
						$('.places-toggles button', currentCarousel).removeClass('active');
						$(this).addClass('active');
					}
				});
			});
		}

		var officeGroup = $('.office-group');

		if ( officeGroup.length ) {
			officeGroup.each( function(e) {
				$('.offices', this).slick({
					infinite: true,
					dots: true,
					appendDots: $('.slick-controls', this),
					arrows: true,
					appendArrows: $('.slick-controls', this),
					prevArrow: '<div class="slick-prev"></div>',
					nextArrow: '<div class="slick-next"></div>',
					mobileFirst: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					rows: 2,
					slidesPerRow: 1,
					responsive: [
					    {
					      breakpoint: 900,
					      settings: {
					        slidesPerRow: 4
					      }
					    },
					    {
					      breakpoint: 650,
					      settings: {
					        slidesPerRow: 3
					      }
					    },
					    {
					      breakpoint: 400,
					      settings: {
					        slidesPerRow: 2
					      }
					    },
					]
				});
			});

			$('.office-tabs li').click( function(e) {
				$('.office-tabs li').removeClass('active');
				$(this).addClass('active');

				var office = $('#'+$(this).data('target'));
				$('.office-group').removeClass('active');
				$(office).addClass('active');
				$(office).find('.offices').slick('setPosition');
			});
			
			$('.office-group h3').click( function(e) {
				// if ( $(this).parents('.office-group').hasClass('active') ) {
				// 	$(this).parents('.office-group').removeClass('active');
				// } else {
				// 	$('.office-group').removeClass('active');
				// 	$(this).parents('.office-group').addClass('active');
				// 	$(this).siblings('.offices').slick('setPosition');
				// }
				$('.office-group').removeClass('active');
				$(this).parents('.office-group').addClass('active');
				$(this).siblings('.offices').slick('setPosition');
			});
		}

		// Guiding Principles 
		var gpPhotoCarousel = $('.ssf-guiding-principles .photo-carousel');

		if ( gpPhotoCarousel.length ) {
			gpPhotoCarousel.each( function(e) {
				// var currentCarousel = this;
				$('.carousel', this).slick({
					infinite: true,
					dots: true,
					appendDots: $('.slick-controls', this),
					arrows: true,
					appendArrows: $('.slick-controls', this),
					nextArrow: '<div class="slick-next"><i class="fa-light fa-arrow-right-long"></i></div>',
					slidesToShow: 1,
					slidesToScroll: 1
				});
			});
		}

		var gpTextCards = $('.ssf-guiding-principles .text-cards');

		if ( gpTextCards.length ) {
			gpTextCards.each( function(e) {
				// var currentCarousel = this;
				$('.carousel', this).slick({
					infinite: true,
					dots: true,
					appendDots: $('.slick-controls', this),
					arrows: true,
					appendArrows: $('.slick-controls', this),
					nextArrow: '<div class="slick-next"><i class="fa-light fa-arrow-right-long"></i></div>',
					mobileFirst: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					responsive: [
					    {
					      breakpoint: 600,
					      settings: {
					        slidesToShow: 2,
					        slidesToScroll: 2,
					      }
					    }
					]

				});
			});
		}

		var gpQuoteCarousel = $('.ssf-guiding-principles .quote-carousel');

		if ( gpQuoteCarousel.length ) {
			gpQuoteCarousel.each( function(e) {
				// var currentCarousel = this;
				var dots = false;
				if ( $('.slide', this).length > 1 ) {
					dots = true;
				}
				$('.carousel', this).slick({
					infinite: true,
					dots: dots,
					appendDots: $('.slick-controls', this),
					arrows: true,
					appendArrows: $('.slick-controls', this),
					nextArrow: '<div class="slick-next"><i class="fa-light fa-arrow-right-long"></i></div>',
					slidesToShow: 1,
					slidesToScroll: 1
				});
			});
		}

		// Pre-footer functions

		var preFooter = $('#pre-footer');

		$('.pre-footer-menu-button', preFooter).click( function(e) {
			e.preventDefault();
			console.log('I was clicked');
			$('.pre-footer-menu-item').removeClass('active');
			$( $(this).attr('href') ).addClass('active');
			$('.window-pane-inner', preFooter).addClass('open');
		});

		$('.back', preFooter).click( function(e) {
			e.preventDefault();
			$('.window-pane-inner', preFooter).removeClass('open');
			history.pushState(null, null, ' ');
		});

		var preFooterHash = $('[href="'+window.location.hash+'"]', preFooter);

		if ( preFooterHash.length ) {
			$(preFooterHash[0]).trigger('click');
		}

		function locationHashChanged() {
		  if ( location.hash ) {
		  	$('[href="'+location.hash+'"]', preFooter).trigger('click');
		  }
		}

		window.onhashchange = locationHashChanged;


	});
	
});